<i18n src="@/locales/components/TimeRepeaterTranslate.json"></i18n>

<template>
	<el-select v-bind="$attrs" v-on="$listeners" class="select-ordinarily">
		<el-option v-for="item in options" :key="item.value" :label="`${item.label}`" :value="item.value" />
	</el-select>
</template>

<script>
export default {
	inheritAttrs: false,
	name: "SelectOrdinarily",
	data() {
		return {
			options: [
				{ label: this.$t("SetPos.First"), value: 1 },
				{ label: this.$t("SetPos.Second"), value: 2 },
				{ label: this.$t("SetPos.Third"), value: 3 },
				{ label: this.$t("SetPos.Fourth"), value: 4 },
				{ label: this.$t("SetPos.Last"), value: -1 }
			]
		};
	}
};
</script>
